<template>
  <div :class="{ padding: !is_modal }">
    <div>
      <div v-show="payload.is_multiple">
        <div v-for="(recommendation, idx) in recommendationList" :key="recommendation.id">
          <h6>המלצה {{idx}} :</h6>
          <p>** {{recommendation.content}}</p>
          <br />
        </div>
      </div>
      <div v-show="payload.is_create" class="columns has-text-left" dir="ltr">
        <div class="column">
          <BaseInput v-model="staged.resource_id" label="Resource Id" type="number" />
        </div>
        <div class="column">
          <p class="bold">Resource Type</p>
          <select
            v-model="staged.resource_type"
          >
            <option
              v-for="option in resource_type_list"
              :value="option"
              :key="option"
            >
              {{ option }}
            </option>
          </select>
        </div>
      </div>
      <br>
      <textarea class="new_note" v-model="recommendation.content"></textarea>
    </div>
    <div
      dir="ltr"
      class="is-flex is-align-items-center"
      :class="{ modal_footer: is_modal }"
    >
      <a
        @click="submit()"
        :class="{ 'is-loading': is_submitting, 'is-outlined': !is_modal }"
        class="button is-info"
        >Submit</a
      >
      <a
        v-show="!payload.is_create"
        @click="remove()"
        :class="{ 'is-loading': is_deleting, 'is-outlined': !is_modal }"
        class="button is-danger margin-left"
        >Delete</a
      >
      <div v-if="payload.resource_type == 'Applicant'" class="is-flex-grow-1">
        <WhatsAppLink :phoneNumber="payload.data.phone_number" :message="whatsappTemplate" linkClass="float-right" />
      </div>
    </div>
  </div>
</template>
<script>
import TextsHelper from '@/custom/classes/texts_helper.js'
import BaseInput from '@/components/BaseInput'
import WhatsAppLink from '@/components/WhatsAppLink'

export default {
  name: 'service-recommendation-modal',
  components: {
    BaseInput,
    WhatsAppLink
  },
  data () {
    return {
      texts_helper: new TextsHelper(),
      recommendation: {},
      recommendationList: [],
      staged: {
        resource_id: '',
        resource_type: '',
        content: ''
      },
      resource_type_list: ['Company', 'Applicant'],
      is_submitting: false,
      is_deleting: false
    }
  },
  props: {
    payload: {
      type: Object,
      default: () => {}
    },
    additional_data: {
      type: Object,
      default: () => {}
    },
    is_modal: {
      type: Boolean,
      default: true
    },
    eager_load: {
      type: Boolean,
      default: false
    },
    is_create: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    is_exist () {
      return this.recommendation.hasOwnProperty('id')
    },
    whatsappTemplate () {
      const env = this.$settings.get({ path: 'operation_name' })
      const template = 'וואו, תודה על ההמלצה החמה! ממש התרגשתי🙌\nאשמח אם ניתן יהיה לפרסם את ההמלצה עלינו גם בפייסבוק שלנו:\n'
      switch (env) {
        case 'Rebase':
          return `${template}https://www.facebook.com/rebase.co.il/`
        case 'Piola':
          return `${template}https://www.facebook.com/PiolaHR`
        case 'Bullrun':
          return `${template}https://www.facebook.com/bullrun/`
        case 'Suitup':
        default:
          return `${template}https://www.facebook.com/suitup.co.il/`
      }
    }
  },
  async created () {
    console.log(this.payload)
    if (this.payload.is_create) {
      return
    }
    if (this.payload.is_multiple) {
      this.recommendationList = await this.$network_utils.getServiceRecommendations({
        resource_id: this.payload.resource_id,
        resource_type: this.payload.resource_type
      })
      this.recommendation.resource_id = '' + this.payload.resource_id
      this.recommendation.resource_type = this.payload.resource_type
      return
    }
    const data = { id: this.payload.id }
    const response = await this.$network_utils.getServiceRecommendation(data)
    this.recommendation = { ...{ content: '' }, ...data, ...response }
  },
  methods: {
    async submit () {
      if (this.recommendation.content.length === 0) {
        this.$utils.emit('show_toast', { text: 'אנא מלא/י טקסט' })
        return
      }
      let content = this.texts_helper.getBoldContent(
        this.recommendation.content,
        'service_recommendation'
      )
      if (content == 'problem') {
        return
      }
      const data = {
        resource_id: this.recommendation.resource_id || this.staged.resource_id,
        resource_type: this.recommendation.resource_type || this.staged.resource_type,
        id: this.recommendation.id,
        content
      }
      this.is_submitting = true
      try {
        if (this.is_exist) {
          await this.$network_utils.updateServiceRecommendation(data)
        } else {
          await this.$network_utils.postServiceRecommendation(data)
        }
        this.$utils.emit('show_toast', { text: 'המלצה נשמרה בהצלחה' })
        this.recommendation.content = ''
        this.is_submitting = false
      } catch {
        this.$utils.emit('show_toast', { text: 'בעייה בשמירת נתונים' })
      }
    },
    async remove () {
      this.is_deleting = true
      await this.$network_utils.deleteServiceRecommendation({ id: this.recommendation.id })
      this.recommendation = {
        content: '',
        resource_id: this.payload.resource_id,
        resource_type: this.payload.resource_type
      }
      this.is_deleting = false
    }
  }
}
</script>
<style scoped>
.padding {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
}
textarea {
  min-width: 100% !important;
}
input {
  min-width: 100% !important;
}
</style>
